var _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoTaxa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 40,
    viewBox: "0 0 36 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_56981",
    "data-name": "Grupo 56981",
    transform: "translate(10.617 10.398)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_56980",
    "data-name": "Grupo 56980"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_43336",
    "data-name": "Caminho 43336",
    d: "M154.167,91a3.164,3.164,0,1,0,3.164,3.164A3.168,3.168,0,0,0,154.167,91Zm0,4.219a1.055,1.055,0,1,1,1.055-1.055A1.056,1.056,0,0,1,154.167,95.22Z",
    transform: "translate(-151.003 -91.001)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_56983",
    "data-name": "Grupo 56983",
    transform: "translate(19.055 18.836)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_56982",
    "data-name": "Grupo 56982"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_43337",
    "data-name": "Caminho 43337",
    d: "M274.167,211a3.164,3.164,0,1,0,3.164,3.164A3.168,3.168,0,0,0,274.167,211Zm0,4.219a1.055,1.055,0,1,1,1.055-1.055A1.056,1.056,0,0,1,274.167,215.22Z",
    transform: "translate(-271.003 -211.001)",
    fill: "#fff"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_56985",
    "data-name": "Grupo 56985",
    transform: "translate(12.727 10.398)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_56984",
    "data-name": "Grupo 56984"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_43338",
    "data-name": "Caminho 43338",
    d: "M191.078,91.177a1.055,1.055,0,0,0-1.463.293l-8.437,12.656a1.055,1.055,0,1,0,1.755,1.17l8.437-12.656A1.055,1.055,0,0,0,191.078,91.177Z",
    transform: "translate(-181.001 -91)",
    fill: "#fff"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_56987",
    "data-name": "Grupo 56987",
    transform: "translate(0 4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_56986",
    "data-name": "Grupo 56986",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Caminho_43339",
    "data-name": "Caminho 43339",
    transform: "translate(0 -0.001)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.945,21.165H29.6V-2.944A1.055,1.055,0,0,0,28.547-4H7.453A1.055,1.055,0,0,0,6.4-2.944V21.165H1.055a1.056,1.056,0,0,0-.633,1.9L17.367,35.79a1.055,1.055,0,0,0,1.267,0L35.579,23.063A1.056,1.056,0,0,0,34.945,21.165ZM18,33.627,4.215,23.274H7.453A1.055,1.055,0,0,0,8.508,22.22V-1.89H27.492V22.22a1.055,1.055,0,0,0,1.055,1.055h3.238Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 17.99992561340332 36.00091934204102 C 17.77703666687012 36.00091934204102 17.55414581298828 35.93046569824219 17.36655616760254 35.78955841064453 L 0.4212761223316193 23.06303024291992 C -0.3875938653945923 22.45553016662598 0.04644613713026047 21.16501998901367 1.054656147956848 21.16501998901367 L 6.398396015167236 21.16501998901367 L 6.398396015167236 -2.944309949874878 C 6.398396015167236 -3.526769876480103 6.870605945587158 -3.998990058898926 7.453076362609863 -3.998990058898926 L 28.54677581787109 -3.998990058898926 C 29.12924575805664 -3.998990058898926 29.60146522521973 -3.526769876480103 29.60146522521973 -2.944309949874878 L 29.60146522521973 21.16501998901367 L 34.94519424438477 21.16501998901367 C 35.956787109375 21.16501998901367 36.38470458984375 22.45750045776367 35.57857513427734 23.06303024291992 L 18.63329696655273 35.78955841064453 C 18.44570541381836 35.93046569824219 18.22281646728516 36.00091934204102 17.99992561340332 36.00091934204102 Z M 4.215196132659912 23.27437973022461 L 17.99992561340332 33.62717056274414 L 31.7846565246582 23.27437973022461 L 28.54677581787109 23.27437973022461 C 27.96430587768555 23.27437973022461 27.49208641052246 22.80216979980469 27.49208641052246 22.21969985961914 L 27.49208641052246 -1.889619946479797 L 8.507765769958496 -1.889619946479797 L 8.507765769958496 22.21969985961914 C 8.507765769958496 22.80216979980469 8.03554630279541 23.27437973022461 7.453076362609863 23.27437973022461 L 4.215196132659912 23.27437973022461 Z",
    stroke: "none",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTaxa);
export default __webpack_public_path__ + "static/media/ico-taxa.c0bb425338b48306bc67069701e9a52c.svg";
export { ForwardRef as ReactComponent };